// گزارش کلی سوخت/روغن، بیمه و تعمیرات خودروها — kind: fuel | insure | repair ، isFuel برای سوخت/روغن
import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { ExcelButton } from '../../components/excel';
import { useFormButtons } from '../../utils/vbPerms';
import { API, qs, toFa, fmtAmt, Field, DateIn, Modal, MsgDialog, visibleColumns, smallBtn } from './carsShared';

const FORMS = { fuel: 'FRMCARFUELALLREPORTS', insure: 'FRMCARINSUREALLREPORTS', repair: 'FRMCARREPAIRALLREPORTS' };
const HEADS = [['0', '—'], ['1', 'سرگروه'], ['2', 'جمع جاری']];
const MONEY = ['مبلغ'];

function OptionsDialog({ dim, list, onChange, onClose }) {
  const [q, setQ] = useState('');
  const shown = list.filter(o => !q || String(o.title).includes(q) || String(o.code).includes(q));
  const setAll = (v) => onChange(list.map(o => (shown.includes(o) ? { ...o, on: v } : o)));
  const reverse = () => onChange(list.map(o => (shown.includes(o) ? { ...o, on: !o.on } : o)));
  const count = list.filter(o => o.on).length;
  return (
    <Modal title={dim.label} onClose={onClose} width="520px"
      footer={<>
        <button onClick={() => setAll(true)} style={ui.btnCancel}>همه</button>
        <button onClick={() => setAll(false)} style={ui.btnCancel}>هیچ</button>
        <button onClick={reverse} style={ui.btnCancel}>معکوس</button>
        <button onClick={onClose} style={ui.btnSave}>تایید ({toFa(count)} از {toFa(list.length)})</button>
      </>}>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="جستجو" style={{ ...ui.input, marginBottom: '8px' }} />
      {shown.map(o => (
        <label key={String(o.id)} style={{ display: 'flex', gap: '8px', padding: '3px 0', fontSize: '12px' }}>
          <input type="checkbox" checked={o.on} onChange={() => onChange(list.map(x => (x === o ? { ...x, on: !x.on } : x)))} />
          <span style={{ color: '#888', minWidth: '60px' }}>{toFa(o.code)}</span><span>{toFa(o.title)}</span>
        </label>
      ))}
    </Modal>
  );
}

function ReportTable({ cols, rows }) {
  let last = null;
  const out = [];
  rows.forEach((r, i) => {
    const head = [r.RepTitle, r.RunningTotalTitle].filter(Boolean).join(' — ');
    if (head && head !== last) {
      out.push(<tr key={`h${i}`}><td colSpan={cols.length} style={{ ...ui.td, background: '#1a2f50', color: '#C8A84B', fontWeight: 700, textAlign: 'right', whiteSpace: 'pre-line' }}>{toFa(head)}</td></tr>);
      last = head;
    }
    out.push(
      <tr key={i} style={{ background: i % 2 ? '#fdf6ec' : '#fff' }}>
        {cols.map(c => {
          const v = r[c];
          const n = typeof v === 'number';
          return <td key={c} style={n ? ui.tdNum : { ...ui.td, whiteSpace: 'pre-line' }}>{n ? (MONEY.includes(c) ? fmtAmt(v) : toFa(v)) : toFa(v ?? '')}</td>;
        })}
      </tr>,
    );
  });
  return (
    <table style={ui.table}>
      <thead style={{ position: 'sticky', top: 0 }}><tr>{cols.map(c => <th key={c} style={ui.th}>{c}</th>)}</tr></thead>
      <tbody>{out}</tbody>
    </table>
  );
}

export default function CarAllReports({ user, onBack, kind = 'fuel', isFuel = 1, year }) {
  const fb = useFormButtons(FORMS[kind] || FORMS.fuel, []);
  const base = `/all-report/${kind}`;
  const [meta, setMeta] = useState(null);
  const [range, setRange] = useState({ from: '', to: '' });
  const [sel, setSel] = useState({});
  const [opts, setOpts] = useState({});
  const [openDim, setOpenDim] = useState(null);
  const [res, setRes] = useState(null);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!fb.open) return;
    API(`${base}/meta/?${qs({ is_fuel: isFuel })}`).then(j => {
      if (!j.ok) { setErr(j.msg); return; }
      setMeta(j); setRange({ from: j.from_date, to: j.to_date });
    });
  }, [fb.open, base, isFuel]);

  const setDim = (k, patch) => setSel(s => ({ ...s, [k]: { ...(s[k] || {}), ...patch } }));

  const openOptions = async (d) => {
    if (!opts[d.key]) {
      const j = await API(`${base}/meta/?${qs({ is_fuel: isFuel, dim: d.key })}`);
      if (!j.ok) { setMsg(j.msg); return; }
      if (!j.data.length) { setMsg('هیچ عنوانی تعریف نشده است.'); return; }
      const list = j.data.map(o => ({ ...o, on: d.key === 'FinancialYear' ? Number(o.id) === Number(year) : true }));
      setOpts(o => ({ ...o, [d.key]: list }));
    }
    setOpenDim(d);
  };
  const closeOptions = () => {
    const list = opts[openDim.key] || [];
    if (list.length && !list.some(o => o.on)) { setMsg(`حداقل یکی از ${openDim.label} ها باید انتخاب شود`); return; }
    setOpenDim(null);
  };

  const run = async () => {
    const p = { is_fuel: isFuel, from: range.from, to: range.to };
    (meta?.dims || []).forEach(d => {
      const s = sel[d.key] || {};
      if (s.col) p[`col_${d.key}`] = 1;
      if (s.head && s.head !== '0') p[`head_${d.key}`] = s.head;
      const list = opts[d.key];
      if (list && list.some(o => !o.on)) {
        const on = list.filter(o => o.on).map(o => o.id);
        const off = list.filter(o => !o.on).map(o => o.id);
        if (on.length <= off.length) p[`inc_${d.key}`] = on.join(','); else p[`exc_${d.key}`] = off.join(',');
      }
    });
    setLoading(true); setErr('');
    const j = await API(`${base}/run/?${qs(p)}`);
    setLoading(false);
    if (!j.ok) { setMsg(j.msg); return; }
    setRes(j);
  };

  const cols = res ? visibleColumns(res.columns, res.data) : [];
  const title = meta?.title || '';
  const toolbar = fb.open && meta ? (
    <>
      <Field label="از تاریخ" width="130px"><DateIn value={range.from} onChange={v => setRange(r => ({ ...r, from: v }))} /></Field>
      <Field label="تا تاریخ" width="130px"><DateIn value={range.to} onChange={v => setRange(r => ({ ...r, to: v }))} /></Field>
      <button onClick={run} disabled={loading} style={ui.btnNew}>{loading ? '⏳ ...' : 'تهیه گزارش'}</button>
      {res && <ExcelButton title={title} subtitle={`از ${range.from} تا ${range.to}`}
        columns={[{ key: 'RepTitle', label: 'سرگروه' }, ...cols.map(c => ({ key: c, label: c, num: res.data.some(r => typeof r[c] === 'number') }))]} rows={res.data} />}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', width: '100%' }}>
        {meta.dims.map(d => {
          const s = sel[d.key] || {};
          const list = opts[d.key];
          const filtered = list && list.some(o => !o.on);
          return (
            <div key={d.key} style={{ display: 'flex', alignItems: 'center', gap: '4px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '3px 6px', background: s.col || (s.head && s.head !== '0') ? '#eef3ff' : '#fff' }}>
              <label style={{ fontSize: '11px' }} title="ستون گزارش">
                <input type="checkbox" checked={!!s.col} onChange={e => setDim(d.key, { col: e.target.checked, head: e.target.checked ? '0' : s.head })} />
              </label>
              <button onClick={() => openOptions(d)} style={smallBtn(filtered ? '#6a1b9a' : undefined)}>{d.label}{filtered ? ' ✓' : ''}</button>
              <select value={s.head || '0'} onChange={e => setDim(d.key, { head: e.target.value, col: e.target.value !== '0' ? false : s.col })}
                style={{ fontSize: '11px', padding: '2px', borderRadius: '5px', border: '1px solid #ccc' }}>
                {HEADS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          );
        })}
      </div>
    </>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title={title || 'گزارش کلی'} subtitle="تدارکات — سامانه ارجان" toolbar={toolbar} error={err}>
        {res ? <ReportTable cols={cols} rows={res.data} /> : <div style={ui.empty}>ستون‌ها و فیلترها را انتخاب و «تهیه گزارش» را بزنید</div>}
        {res && res.data.length === 0 && <div style={ui.empty}>اطلاعاتی برای گزارش وجود ندارد</div>}
      </ListPage>
      {openDim && <OptionsDialog dim={openDim} list={opts[openDim.key] || []}
        onChange={l => setOpts(o => ({ ...o, [openDim.key]: l }))} onClose={closeOptions} />}
      {msg && <MsgDialog text={msg} onClose={() => setMsg('')} />}
    </>
  );
}
